/* eslint-disable max-len */
import React, { FC, useState } from 'react'
import { CustomAlert, CustomAlertConditions } from '../../../../states/types/setting'
import Tips from '../../common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { ATTENDANCE_CONDITION_TYPE, CATEGORY_NAME, CONDITION_TYPE, OPERATOR_TYPE, TIMING_TYPE, TIMING_VALUES } from '../../../constants/customAlert'
import { standardToAttendanceTime } from '../../../../utils/date'

interface Props {
  customAlert: CustomAlert,
  openCustomAlertModalCallback: (event: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>) => void,
  duplicateCustomAlertCallback: (id: number) => void,
  openConfirmationModalCallback: (type: string, id: number) => void,
  changeAlertStatusCallback: (id: number, status: string) => void,
}

const buildAlertCondition = (condition: CustomAlertConditions) => {
  let value: string | null = ""
  let unit = ""
  let value_2: string | null = ""
  let unit_2 = ""
  if (
    condition.condition_type === "biz_point"
    || condition.condition_type === "biz_point_hour"
    || condition.condition_type === "category_biz_point"
    || condition.condition_type === "application_biz_point"
  ) {
    value = condition.biz_point || "0"
    unit = "biz"
  } else if (
    condition.condition_type === "daily_work_time"
    || condition.condition_type === "weekly_work_time"
    || condition.condition_type === "monthly_work_time"
    || condition.condition_type === "daily_over_time"
    || condition.condition_type === "weekly_over_time"
    || condition.condition_type === "monthly_over_time"
    || condition.condition_type === "holiday_work_time"
    || condition.condition_type === "holiday_active_time"
  ) {
    value = condition.hours?.toString() || "0"
    unit = "時間"
  } else if (
    condition.condition_type === "active_time"
    || condition.condition_type === "not_active_time"
    || condition.condition_type === "category_time"
    || condition.condition_type === "application_time"
  ) {
    value = condition.set_hour?.toString() || "0"
    unit = "時間"
    value_2 = condition.set_minute?.toString() || "0"
    unit_2 = "分"
  } else if (
    condition.condition_type === "labeling_rate"
  ) {
    value = condition.value || "0"
    unit = "%"
  } else {
    value = standardToAttendanceTime(condition.set_hour ?? 0, condition.set_minute ?? 0)
    unit = ""
  }
  return (
    <>
      <span
        style={{
          fontSize: "18px",
        }}
      >
        {value}
      </span>
      {unit}
      {
        !!value_2 && value_2 !== "0" ? (
          <>
            <span
              style={{
                fontSize: "18px",
              }}
            >
              {value_2}
            </span>
            {unit_2}
          </>
        ) : (
          <></>
        )
      }
    </>
  )
}

const CustomAlertDetail: FC<Props> = (props) => {
  const {
    customAlert,
    openCustomAlertModalCallback,
    duplicateCustomAlertCallback,
    openConfirmationModalCallback,
    changeAlertStatusCallback,
  } = props

  const {
    teamList,
  } = useSelector((state: RootState) => (state))

  const [isOpenDetail, setIsOpenDetail] = useState<boolean>(false)

  const buildMembers = (teamId: number, selectedMemberIds: number[]) => {
    const teamMember = teamList.teams.find((v) => v.team_id === teamId)?.members || []
    if (selectedMemberIds.length) {
      return teamMember.filter((value) => selectedMemberIds.includes(value.id)).map((value) => value.name).join(',')
    }
    return teamMember.map((value) => value.name).join(',')
  }

  return (
    <>
      <div
        style={{
          position: "relative",
          border: `solid 1px ${customAlert.status === "started" ? "#999999" : "#CCCCCC"}`,
          borderRadius: "4px",
          padding: "8px",
          backgroundColor: customAlert.status === "started" ? "#FFFFFF" : "#EEEEEE",
          color: customAlert.status === "started" ? "#333333" : "#999999",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "46px",
            zIndex: 1,
          }}
          onClick={() => setIsOpenDetail(!isOpenDetail)}
          role="none"
        />
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: "8px",
            padding: "4px 8px",
            borderBottom: isOpenDetail ? `solid 1px ${customAlert.status === "started" ? "#666666" : "#CCCCCC"}` : "none",
            marginBottom: isOpenDetail ? "8px" : "0",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              zIndex: 2,
              minWidth: "170px",
            }}
          >
            <div
              key={`${customAlert.id}_${customAlert.status}`}
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "4px",
                fontSize: "10px",
                minWidth: 0,
              }}
            >
              <Tips
                description={customAlert.status === "started" ? "このアラートは有効になっています" : "このアラートは無効になっています"}
                className=""
                icon={false}
              >
                <div
                  style={{
                    color: customAlert.status === "started" ? "#0D9554" : "#FF0000",
                    fontSize: "16px",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', customAlert.status === "started" ? 'bell' : 'bell-slash']} fixedWidth />
                </div>
              </Tips>
              <div style={{ flexShrink: 0 }}>
                アラート名
              </div>
              <Tips
                description={customAlert.name}
                className=""
                icon={false}
                style={{
                  minWidth: 0,
                }}
              >
                <>
                  <div
                    data-type="update"
                    data-id={customAlert.id}
                    onClick={(event) => customAlert.status === "started" && openCustomAlertModalCallback(event)}
                    style={{
                      fontSize: "18px",
                      color: customAlert.status === "started" ? "#4472BA" : "#999999",
                      cursor: customAlert.status === "started" ? "pointer" : "default",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      minWidth: 0,
                      whiteSpace: "nowrap",
                    }}
                    role="none"
                  >
                    {customAlert.name}
                  </div>
                </>
              </Tips>
            </div>
            <button
              type="button"
              onClick={() => setIsOpenDetail(!isOpenDetail)}
              style={{
                border: "solid 1px #999999",
                borderRadius: "4px",
                padding: "4px",
                fontSize: "10px",
                color: "#666666",
                backgroundColor: "#FFFFFF",
                display: "flex",
                flexShrink: 0,
                alignItems: "center",
                gap: "2px",
              }}
            >
              {isOpenDetail ? "閉じる" : "開く"}
            </button>
          </div>
          <div
            style={{
              display: "flex",
              flexShrink: 0,
              alignItems: "center",
              justifyContent: "right",
              gap: "8px",
            }}
          >
            {
              !isOpenDetail && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: "4px",
                      fontSize: "10px",
                    }}
                  >
                    <div>
                      アラート対象
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "baseline",
                        gap: "2px",
                      }}
                    >
                      <div>
                        {teamList.teams.find((w) => customAlert.custom_alert_team_ids.includes(w.team_id))?.name}
                      </div>
                      <div
                        style={{
                          fontSize: "10px",
                        }}
                      >
                        (
                        {
                          customAlert.custom_alert_team_member_ids.length ? (
                            "一部選択"
                          ) : (
                            "全員"
                          )
                        }
                        )
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: "4px",
                      fontSize: "10px",
                    }}
                  >
                    {
                      customAlert.notice_type === "slack" && customAlert.slack_channel_name ? (
                        <>
                          <div>
                            アラート通知
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "baseline",
                            }}
                          >
                            Slack
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            アラート受信人数
                          </div>
                          <div
                            style={{
                              fontSize: "16px",
                              display: "flex",
                              alignItems: "baseline",
                            }}
                          >
                            <div>
                              {
                                customAlert.send_to_member ? (
                                  <>
                                    {
                                      Array.from(new Map([...customAlert.recipients.managers, ...customAlert.recipients.members].map((v) => [v.id, v])).values()).length
                                    }
                                  </>
                                ) : (
                                  <>
                                    {customAlert.recipients.managers.length}
                                  </>
                                )
                              }
                            </div>
                            <div
                              style={{
                                fontSize: "10px",
                              }}
                            >
                              人
                            </div>
                          </div>
                        </>
                      )
                    }
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: "4px",
                      fontSize: "10px",
                    }}
                  >
                    <div>
                      アラート頻度
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                      }}
                    >
                      <div>
                        {TIMING_TYPE.find((v) => v.value === customAlert.send_timing_type)?.label}
                      </div>
                      {
                        customAlert.send_timing_type !== TIMING_VALUES.IMMEDIATE && (
                          <div>
                            {standardToAttendanceTime(customAlert.send_timing_hour, customAlert.send_timing_minute)}
                          </div>
                        )
                      }
                    </div>
                  </div>
                </>
              )
            }
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "4px",
                fontSize: "10px",
              }}
            >
              <div>
                現在の状況
              </div>
              <div
                style={{
                  fontSize: "16px",
                  color: customAlert.status === "started" ? "#0D9554" : "#FF0000",
                }}
              >
                {customAlert.status === "started" ? "有効" : "無効"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                zIndex: 2,
              }}
            >
              <Tips
                description="アラートの複製"
                className=""
                icon={false}
              >
                <>
                  <button
                    type="button"
                    onClick={() => duplicateCustomAlertCallback(customAlert.id)}
                    style={{
                      border: "solid 1px #999999",
                      borderRadius: "4px",
                      padding: "4px",
                      fontSize: "10px",
                      color: "#666666",
                      backgroundColor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <FontAwesomeIcon icon={['far', 'clone']} fixedWidth />
                    複製
                  </button>
                </>
              </Tips>
              {
                customAlert.status === "started" ? (
                  <>
                    <Tips
                      description="アラートの編集"
                      className=""
                      icon={false}
                    >
                      <>
                        <button
                          type="button"
                          data-type="update"
                          data-id={customAlert.id}
                          onClick={(event) => openCustomAlertModalCallback(event)}
                          style={{
                            border: "solid 1px #999999",
                            borderRadius: "4px",
                            padding: "4px",
                            fontSize: "10px",
                            color: "#666666",
                            backgroundColor: "#FFFFFF",
                            display: "flex",
                            alignItems: "center",
                            gap: "2px",
                          }}
                        >
                          <FontAwesomeIcon icon={['fas', 'cog']} fixedWidth />
                          編集
                        </button>
                      </>
                    </Tips>
                    <Tips
                      description="アラートの停止"
                      className=""
                      icon={false}
                    >
                      <>
                        <button
                          type="button"
                          onClick={() => openConfirmationModalCallback("stop", customAlert.id)}
                          style={{
                            border: "solid 1px #999999",
                            borderRadius: "4px",
                            padding: "4px",
                            fontSize: "10px",
                            color: "#FF0000",
                            backgroundColor: "#FFFFFF",
                            display: "flex",
                            alignItems: "center",
                            gap: "2px",
                          }}
                        >
                          <FontAwesomeIcon icon={['fas', 'bell-slash']} fixedWidth />
                          停止
                        </button>
                      </>
                    </Tips>
                  </>
                ) : (
                  <Tips
                    description="アラートの開始"
                    className=""
                    icon={false}
                  >
                    <>
                      <button
                        type="button"
                        onClick={() => changeAlertStatusCallback(customAlert.id, "started")}
                        style={{
                          border: "solid 1px #999999",
                          borderRadius: "4px",
                          padding: "4px",
                          fontSize: "10px",
                          color: "#0D9554",
                          backgroundColor: "#FFFFFF",
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        <FontAwesomeIcon icon={['fas', 'bell']} fixedWidth />
                        開始
                      </button>
                    </>
                  </Tips>
                )
              }
              <Tips
                description="アラートの削除"
                className=""
                icon={false}
              >
                <>
                  <button
                    type="button"
                    onClick={() => openConfirmationModalCallback("delete", customAlert.id)}
                    style={{
                      border: "solid 1px #999999",
                      borderRadius: "4px",
                      padding: "4px",
                      fontSize: "10px",
                      color: "#FF0000",
                      backgroundColor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <FontAwesomeIcon icon={['fas', 'trash-alt']} fixedWidth />
                    削除
                  </button>
                </>
              </Tips>
            </div>
          </div>
        </div>
        {
          isOpenDetail && (
            <>
              <div
                style={{
                  padding: "8px",
                }}
              >
                <div
                  style={{
                    padding: "0 8px",
                    marginBottom: "4px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    color: customAlert.status === "started" ? "#666666" : "#999999",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'tag']} fixedWidth />
                  アラート名
                </div>
                <div
                  style={{
                    padding: "8px",
                    backgroundColor: "#F7F7F7",
                    borderRadius: "4px",
                    display: "flex",
                    flexFlow: "column",
                    gap: "8px",
                  }}
                >
                  {customAlert.name}
                </div>
              </div>
              <div
                style={{
                  padding: "8px",
                }}
              >
                <div
                  style={{
                    padding: "0 8px",
                    marginBottom: "4px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    color: customAlert.status === "started" ? "#666666" : "#999999",
                  }}
                >
                  <FontAwesomeIcon icon={['far', 'clock']} fixedWidth />
                  アラートの通知頻度
                </div>
                <div
                  style={{
                    padding: "8px",
                    backgroundColor: "#F7F7F7",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "baseline",
                    gap: "2px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    {TIMING_TYPE.find((v) => v.value === customAlert.send_timing_type)?.label}
                    {customAlert.send_timing_type !== TIMING_VALUES.IMMEDIATE && (
                      `${standardToAttendanceTime(customAlert.send_timing_hour, customAlert.send_timing_minute)}`
                    )}
                  </div>
                  <div>
                    にアラートが通知されます
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{
                    padding: "8px",
                    width: "50%",
                  }}
                >
                  <div
                    style={{
                      padding: "0 8px",
                      marginBottom: "4px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      color: customAlert.status === "started" ? "#a50404" : "#999999",
                    }}
                  >
                    <FontAwesomeIcon icon={['far', 'eye']} fixedWidth />
                    アラートの対象になるチーム(メンバー)
                  </div>
                  <div
                    style={{
                      padding: "8px",
                      backgroundColor: customAlert.status === "started" ? "#ffeded" : "#F7F7F7",
                      height: "calc(100% - 18px)",
                      border: "solid 1px #CCCCCC",
                      borderRadius: "4px",
                    }}
                  >
                    {teamList.teams.find((w) => customAlert.custom_alert_team_ids.includes(w.team_id))?.name}
                    &nbsp;
                    (
                    {
                      customAlert.custom_alert_team_member_ids.length ? (
                        buildMembers(customAlert.custom_alert_team_ids[0], customAlert.custom_alert_team_member_ids)
                      ) : (
                        "全員"
                      )
                    }
                    )
                  </div>
                </div>
                <div
                  style={{
                    padding: "8px",
                    width: "50%",
                  }}
                >
                  <div
                    style={{
                      padding: "0 8px",
                      marginBottom: "4px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      color: customAlert.status === "started" ? "#00954e" : "#999999",
                    }}
                  >
                    <FontAwesomeIcon icon={['far', 'paper-plane']} fixedWidth />
                    {
                      customAlert.notice_type === "slack" && customAlert.slack_channel_name ? (
                        <>
                          アラートを通知するSlackチャンネル
                        </>
                      ) : (
                        <>
                          アラートを受け取るマネージャー・メンバー
                        </>
                      )
                    }
                  </div>
                  <div
                    style={{
                      padding: "8px",
                      backgroundColor: customAlert.status === "started" ? "#e6fff3" : "#F7F7F7",
                      border: "solid 1px #CCCCCC",
                      borderRadius: "4px",
                    }}
                  >
                    {
                      customAlert.notice_type === "mail" && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                width: "120px",
                              }}
                            >
                              チームマネージャー
                            </div>
                            <div
                              style={{
                                width: "calc(100% - 128px)",
                              }}
                            >
                              {customAlert.recipients.managers.map((v) => v.name).join(',')}
                            </div>
                          </div>
                          {
                            customAlert.send_to_member && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  borderTop: "solid 1px #CCCCCC",
                                  marginTop: "8px",
                                  paddingTop: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "120px",
                                  }}
                                >
                                  対象のメンバー
                                </div>
                                <div
                                  style={{
                                    width: "calc(100% - 128px)",
                                  }}
                                >
                                  {customAlert.recipients.members.map((v) => v.name).join(',')}
                                </div>
                              </div>
                            )
                          }
                        </>
                      )
                    }
                    {
                      customAlert.notice_type === "slack" && customAlert.slack_channel_name && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {
                              customAlert.slack_channel_private ? (
                                <FontAwesomeIcon icon={['fas', 'lock']} />
                              ) : (
                                <FontAwesomeIcon icon={['fas', 'hashtag']} />
                              )
                            }
                            <span>
                              {customAlert.slack_channel_name}
                            </span>
                          </div>
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
              <div
                style={{
                  padding: "8px",
                }}
              >
                <div
                  style={{
                    padding: "0 8px",
                    marginBottom: "4px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    color: customAlert.status === "started" ? "#0077a7" : "#999999",
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'list']} fixedWidth />
                  アラートの条件
                </div>
                <div
                  style={{
                    padding: "8px",
                    backgroundColor: customAlert.status === "started" ? "#eaf9ff" : "#F7F7F7",
                    border: "solid 1px #CCCCCC",
                    borderRadius: "4px",
                    display: "flex",
                    flexFlow: "column",
                    gap: "8px",
                  }}
                >
                  {
                    customAlert.custom_alert_conditions.map((condition) => (
                      <div
                        key={condition.condition_type}
                        className="conditions"
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                          borderBottom: "solid 1px #CCCCCC",
                          padding: "2px 8px",
                        }}
                      >
                        <div
                          className="condition_name"
                          style={{
                            display: "flex",
                            gap: "4px",
                            minWidth: "300px",
                          }}
                        >
                          <div>
                            {[...CONDITION_TYPE, ...ATTENDANCE_CONDITION_TYPE].find((v) => v.value === condition.condition_type)?.label}
                          </div>
                          {
                            (
                              condition.condition_type === "category_time"
                              || condition.condition_type === "category_biz_point"
                            ) && (
                              <div className="target">
                                {`【${CATEGORY_NAME.find((v) => v.id === Number(condition.alert_target))?.label || "-"}】`}
                              </div>
                            )
                          }
                          {
                            (
                              condition.condition_type === "application_time"
                              || condition.condition_type === "application_biz_point"
                            ) && (
                              <div className="target">
                                {`【${condition.alert_target}】`}
                              </div>
                            )
                          }
                        </div>
                        <div className="condition_detail">
                          {buildAlertCondition(condition)}
                          {
                            (condition.condition_type === "start_time" || condition.condition_type === "end_time") ? (
                              <>
                                {OPERATOR_TYPE.find((v) => v.value === condition.operator_type)?.label_1}
                              </>
                            ) : (
                              <>
                                {OPERATOR_TYPE.find((v) => v.value === condition.operator_type)?.label_2}
                              </>
                            )
                          }
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </>
          )
        }
      </div>
    </>
  )
}

export default CustomAlertDetail
